import { useEffect } from 'react';
import { toast } from 'sonner';

export function OfflineNotification() {
    useEffect(() => {
        const handleOnline = () => {
            toast.success('Back online', {
                description: 'Your internet connection has been restored',
            });
        };

        const handleOffline = () => {
            toast.error('No internet connection', {
                description: 'You are currently offline. Some features may not work.',
                duration: Infinity, // Keep showing until back online
            });
        };

        // Check initial status
        if (!navigator.onLine) {
            handleOffline();
        }

        // Listen for online/offline events
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return null;
}
